import React, { useState, useEffect } from 'react';
import { doc, updateDoc, addDoc, collection, serverTimestamp } from 'firebase/firestore';

const LeadEditModal = ({ db, user, onClose, onSave, initialLeadData }) => {
    const [formData, setFormData] = useState({ contactName: '', company: '', email: '', phone: '', interest: '', notes: '' });
    const [isSaving, setIsSaving] = useState(false);
    const isEditMode = initialLeadData && initialLeadData.id;

    useEffect(() => {
        if (isEditMode) {
            setFormData({
                contactName: initialLeadData.contactName || '',
                company: initialLeadData.company || '',
                email: initialLeadData.email || '',
                phone: initialLeadData.phone || '',
                interest: initialLeadData.interest || '',
                notes: initialLeadData.notes || '',
            });
        }
    }, [initialLeadData, isEditMode]);

    const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            if (isEditMode) {
                const leadRef = doc(db, "tradeshow_leads", initialLeadData.id);
                await updateDoc(leadRef, formData);
            } else {
                await addDoc(collection(db, "tradeshow_leads"), { ...formData, sellerId: user.uid, sellerName: user.name || user.email, status: 'new', createdAt: serverTimestamp() });
            }
            onSave();
        } catch (error) {
            console.error("Error saving lead:", error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
                <h2 className="text-2xl font-bold mb-4">{isEditMode ? 'Editar Lead' : 'Nuevo Lead'}</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <input name="contactName" value={formData.contactName} onChange={handleChange} placeholder="Nombre del Contacto" required className="w-full p-2 border rounded" />
                    <input name="company" value={formData.company} onChange={handleChange} placeholder="Empresa" required className="w-full p-2 border rounded" />
                    <input name="email" type="email" value={formData.email} onChange={handleChange} placeholder="Email" className="w-full p-2 border rounded" />
                    <input name="phone" value={formData.phone} onChange={handleChange} placeholder="Teléfono" required className="w-full p-2 border rounded" />
                    <select name="interest" value={formData.interest} onChange={handleChange} className="w-full p-2 border rounded"><option value="">Nivel de Interés...</option><option value="high">Alto</option><option value="medium">Medio</option><option value="low">Bajo</option></select>
                    <textarea name="notes" value={formData.notes} onChange={handleChange} placeholder="Notas adicionales..." rows="3" className="w-full p-2 border rounded"></textarea>
                    <div className="flex justify-end gap-4">
                        <button type="button" onClick={onClose} disabled={isSaving} className="px-4 py-2 text-sm font-medium bg-gray-200 rounded-md hover:bg-gray-300 disabled:bg-gray-100">Cancelar</button>
                        <button type="submit" disabled={isSaving} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-blue-300">{isSaving ? 'Guardando...' : 'Guardar'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LeadEditModal;
